import { createContext, useContext } from 'react';
import LanguageLocales from '@helsenorge/core-utils/constants/languages';
import { getResources } from '../../resources';
export const defaultResources = getResources(LanguageLocales.NORWEGIAN);
const ResourcesContext = createContext(defaultResources);
export const useResourcesContext = () => useContext(ResourcesContext);
export const ResourcesContextProvider = ResourcesContext.Provider;
